import { Button } from 'component/Button'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { PhoneInput } from 'page/UserDataBanner/PhoneInput'
import { store } from 'store/store'

export const PhoneForm = observer(() => {
  const { phone } = store.banner
  const { description, agreement } = store.options?.email ?? {}
  const placeholder = description || i18n('PhonePlaceholder')

  const onSend = useLatestCallback(async () => {
    if (phone.check()) {
      void phone.save()
      store.banner.close()
    }
  })

  return <Vertical gap={12}>
    <Typo size={16}>{placeholder}</Typo>
    <PhoneInput it={phone} />
    <Button large primary action={onSend}>
      {i18n('SendData')}
    </Button>
    <Typo size={10} secondary center pre>{agreement || i18n('SendDataAgreement')}</Typo>
  </Vertical>
})
